import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { ComposerManager } from "./ComposerManager";

const ComposerContext = createContext<ComposerManager<any> | null>(null);

export function ComposerProvider({
  composer,
  children,
}: {
  composer: ComposerManager<any>;
  children: ReactNode;
}) {
  return (
    <ComposerContext.Provider value={composer}>
      {children}
    </ComposerContext.Provider>
  );
}

export function useComposerContext<
  TMeta extends Record<string, unknown> = Record<string, unknown>,
>(): ComposerManager<TMeta> {
  const composer = useContext(ComposerContext);
  if (!composer) {
    throw new Error(
      "useComposerContext must be used within a <ComposerProvider>",
    );
  }
  return composer as ComposerManager<TMeta>;
}
